import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const Layout = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: var(--section-snow-background-color, var(--snow));
  /* add box sizing border-box to all elements */
  box-sizing: border-box;
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
`;

export const Header = styled.header`
  padding-top: 32px;
  padding-right: 32px;
  padding-bottom: 24px;
  padding-left: 32px;

  @media (min-width: ${breakpoints[0]}) {
    padding-bottom: 28px;
  }
`;
